<template>
  <div class="ui-carousel-with-button" :style="styles">
    <div
      class="ui-carousel-arrow"
    >
      <UiButtonIcon
        ref="prev"
        icon="mdi/chevron-left"
        icon-size="size-none"
        class="ui-carousel-arrow-icon"
        aria-hidden="true"
        arialabel=""
        tabindex="-1"
      />
    </div>

    <UiCarousel
      class="ui-carousel-body"
      :next-button="next?.$el"
      :prev-button="prev?.$el"
      :gap="itemGap"
      :tag="tag"
    >
      <slot />
    </UiCarousel>

    <div
      class="ui-carousel-arrow"
    >
      <UiButtonIcon
        ref="next"
        icon="mdi/chevron-right"
        icon-size="size-none"
        class="ui-carousel-arrow-icon"
        aria-hidden="true"
        arialabel=""
        tabindex="-1"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  tag?: string
  itemWidth?: number
  itemGap?: number
}

const props = defineProps<Props>()

const styles = computed(() => {
  return {
    '--item-width': `${props.itemWidth}px`,
  }
})
const next = ref()
const prev = ref()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.ui-carousel-with-button {
  width: 100%;
  height: 100%;
  display: flex;
  gap: 0.5rem;

  .ui-button-icon:disabled {
    opacity: 0.5;
  }

  :deep(.ui-carousel-item) {
    width: var(--item-width);
    min-width: var(--item-width);
    height: 100%;
  }
}

.ui-carousel-arrow {
  display: none;
  @include is-tablet {
    display: flex;
    flex: 0 0 70px;
  }

  > :deep(button) {
    @include is-tablet {
      display: flex;
      width: 100%;
      height: 100%;
      cursor: pointer;
      border-color: $white !important;
      border-radius: 0 !important;
      color: $jps-gray-900;
      outline: none !important;
      box-shadow: none !important;
      &:hover {
        color: $jps-gray-900;
        background: $jps-gray-100;
      }
      &:disabled {
        color: $jps-gray-500;
        cursor: default;
      }
    }
  }
}
.ui-carousel-arrow-icon {
  width: 4rem;
  height: 4rem;
}
.ui-carousel-body {
  flex-grow: 1;
}
</style>
